// @flow
import * as React from 'react';
import {useState} from 'react';

import Button from 'sail/Button';
import Dialog, {DialogContent, DialogFooter, DialogHeader} from 'sail/Dialog';
import {Body, BodyAlt} from 'sail/Text';
import {TextInput} from 'sail/Input';
import Group from 'sail/Group';
import {useDiagramGenerator} from 'docs/data';

type AddEventProps = {|
  event: string,
  setEvent: (string) => void,
|};

const AddEvent = ({event, setEvent}: AddEventProps) => (
  <Group spacing={4}>
    <label htmlFor="edgeEvent">
      <BodyAlt>Webhook event</BodyAlt>
    </label>
    <TextInput id="edgeEvent" onChange={setEvent} value={event} />
  </Group>
);

export const AddEdge = () => {
  const {type, addEdgeContent} = useDiagramGenerator();
  const [label, setLabel] = useState('');
  const [event, setEvent] = useState('');
  const [error, setError] = useState('');

  return (
    <Dialog width="medium">
      <DialogHeader title="Add edge content" />
      <DialogContent padding={20}>
        <Group spacing={20}>
          <Group spacing={4}>
            <label htmlFor="edgeLabel">
              <BodyAlt>Edge label</BodyAlt>
            </label>
            <TextInput
              id="edgeLabel"
              onChange={setLabel}
              value={label}
              invalid={!!error}
              placeholder={
                type === 'sequence'
                  ? 'Add a label to the edge'
                  : 'Add an optional label to the edge'
              }
            />
            {error ? <Body>{error}</Body> : ''}
          </Group>
          {type === 'sequence' && (
            <AddEvent event={event} setEvent={setEvent} />
          )}
        </Group>
      </DialogContent>
      <DialogFooter
        end={
          <Button
            label="Add"
            onClick={() => {
              if (type === 'sequence' && !label) {
                setError('A label is required for sequence diagram edges');
                setTimeout(() => {
                  setError('');
                }, 5000);
              } else {
                addEdgeContent(label, event);
              }
            }}
          />
        }
      />
    </Dialog>
  );
};
